/**
 * Linhas de tabela da Industrialização em cards (≤1024px) — redesenho
 * mobile do legado (2026-09-24, opção B). Cada item já vem mapeado
 * ({ id, titulo, sub, selo, barra, meta: [[rotulo, valor]], onAbrir });
 * o toque abre o mesmo LoteDrawer que o clique na linha.
 */
import React from "react";
import {
  CardItem,
  CardList,
  CardMeta,
  CardSub,
  CardTitulo,
  CardTopo,
  CardVazio,
} from "../../components/ListaCompacta/styles";
import { formatarData } from "../../utils/calculos";

const VAZIO = "—";

// Ano com 2 dígitos na meta ("10/11/26").
export function dataCurta(valor) {
  const texto = formatarData(valor);
  return typeof texto === "string" ? texto.replace(/\/(\d{2})(\d{2})$/, "/$2") : texto;
}

function ativarComTeclado(event, acao) {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    acao();
  }
}

export default function CardsLinhas({ itens, vazio = "Nenhum registro.", testId }) {
  if (!itens.length) {
    return (
      <CardList data-testid={testId}>
        <CardVazio>{vazio}</CardVazio>
      </CardList>
    );
  }
  return (
    <CardList data-testid={testId}>
      {itens.map((item) => {
        const meta = item.meta.filter(([, v]) => v != null && v !== "" && v !== VAZIO);
        return (
          <CardItem
            key={item.id}
            role="button"
            tabIndex={0}
            $clicavel
            $barra={item.barra}
            onClick={item.onAbrir}
            onKeyDown={(event) => ativarComTeclado(event, item.onAbrir)}
          >
            <CardTopo>
              <CardTitulo title={item.titulo}>{item.titulo}</CardTitulo>
              {item.selo && <span className="selo">{item.selo}</span>}
            </CardTopo>
            {item.sub && <CardSub title={item.sub}>{item.sub}</CardSub>}
            {meta.length > 0 && (
              <CardMeta>
                {meta.map(([rotulo, valor], i) => (
                  <span className="par" key={rotulo}>
                    {i > 0 && <span className="sep">· </span>}
                    <span className="k">{rotulo}</span> <b>{valor}</b>
                  </span>
                ))}
              </CardMeta>
            )}
          </CardItem>
        );
      })}
    </CardList>
  );
}
